import { Component, OnInit, Input, OnChanges, ChangeDetectorRef, ChangeDetectionStrategy, ApplicationRef } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit, OnChanges {

  @Input() notification = '';
  @Input() order;
  @Input() channel;

  icon = '';

  constructor(private cd: ChangeDetectorRef, private appRef: ApplicationRef) { }

  ngOnInit() {
  }

  ngOnChanges() {

    const statusPriority = {
      pending: -1,
      processing: 1,
      waiting: 2,
      sent: 3,
      cancel: 0,
      error: 4,
    }
    // console.log('TCL: NotificationsComponent -> ngOnChanges -> ngOnChanges', this.icon)

    let notifications = this.order.notifications.
      filter(el => {
        if (el.status == 'pending' || el.status == 'canceled') return false;
        return el.channel == this.channel;
      }).sort((a, b) => {
        let timeDiff = +new Date(b.queued_at) - +new Date(a.queued_at);
        if (timeDiff != 0) return timeDiff
        else return statusPriority[b.status] - statusPriority[a.status];

      });

    let lastNotification = notifications[0]


    if (!lastNotification) {
      this.icon = '';
      this.cd.detectChanges();
      return;
    }

    if (lastNotification.channel == 'phone')
      if (lastNotification.type !== 'start_search_again' && lastNotification.type !== 'cab_arrived') return '';

    this.icon = lastNotification.channel + '-' + lastNotification.status;

  }

}



// WEBPACK FOOTER //
// ./src/app/dashboard/notifications/notifications.component.ts